angular.module('unica_tools.tools_controllers')

.controller('ToolsQrcodeController', function(
	$rootScope, $scope, $state, ToolQrcodeService
) {

	$scope.qrcodeData = {};
	$scope.image = null;

	$scope.createQrcode = function() {
		$scope.showLoader();

		// var qrcodeData = angular.copy($scope.qrcodeData);

		ToolQrcodeService
			.generate($scope.qrcodeData)
			.then(function(data) {
				$scope.hideLoader();
				$scope.showSuccessMsg('Qrcode generato con successo!', '');

				$scope.image = data;
			});

	};

})

;